import ActionTypes from '../constants/ActionTypes'; 

const initialState = {
    loading: false,
    companies: [],
    managementUnitData: [],
    isUpdatingMaster: false,
    error: null,
};

const companyReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_COMPANIES_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.FETCH_COMPANIES_SUCCESS:
            return { ...state, loading: false, companies: action.payload};
        case ActionTypes.FETCH_COMPANIES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionTypes.FETCH_MANAGEMENT_UNIT_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.FETCH_MANAGEMENT_UNIT_SUCCESS:
            return { ...state, loading: false };
        case ActionTypes.FETCH_MANAGEMENT_UNIT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionTypes.FETCH_MANAGEMENT_UNIT_STATUS_REQUEST:
            return { ...state, loading: false };
        case ActionTypes.FETCH_MANAGEMENT_UNIT_STATUS_SUCCESS:
            return {
                ...state,
                isFetching: {
                    ...state.isFetching,
                    [ActionTypes.FETCH_MANAGEMENT_UNIT_STATUS_REQUEST]: false,
                },
                isUpdatingMaster: Number(action.payload?.is_updating_master) === 1,
                error: null,
            };
        case ActionTypes.FETCH_MANAGEMENT_UNIT_STATUS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionTypes.REGISTER_COMPANY_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.REGISTER_COMPANY_SUCCESS:
            return { ...state, loading: false, message: action.payload };
        case ActionTypes.REGISTER_COMPANY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionTypes.REPLACE_COMPANY_REQUEST:
            return { ...state, loading: true};
        case ActionTypes.REPLACE_COMPANY_SUCCESS:
            return { ...state, loading: false, message: action.payload }; 
        case ActionTypes.REPLACE_COMPANY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default companyReducer;
